import React, { useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

interface CustomDatePickerProps {
  selected: Date;
  initialDate: Date;
  onChange: (date: Date) => void;
}

const daysOfWeek = ["S", "M", "T", "W", "Th", "F", "S"];

function getDaysInMonth(year: number, month: number): number {
  return new Date(year, month + 1, 0).getDate();
}

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({
  selected,
  initialDate,
  onChange,
}) => {
  const [currentDate, setCurrentDate] = useState(new Date(initialDate));

  const startOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1,
  );
  const dayOfWeek = startOfMonth.getDay();
  const daysInMonth = getDaysInMonth(
    currentDate.getFullYear(),
    currentDate.getMonth(),
  );

  const handlePrevMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1),
    );
  };

  const handleNextMonth = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1),
    );
  };

  const renderDays = () => {
    const cells = [];
    // Empty cells for the days before the first of the month
    for (let i = 0; i < dayOfWeek; i++) {
      cells.push(<td key={`empty-${i}`} className="p-1"></td>);
    }
    for (let day = 1; day <= daysInMonth; day++) {
      const dateObj = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        day,
      );
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const dateWithoutTime = new Date(
        dateObj.getFullYear(),
        dateObj.getMonth(),
        dateObj.getDate(),
      );
      const isFuture = dateWithoutTime.getTime() > today.getTime();
      const isSelected = dateObj.toDateString() === selected.toDateString();
      cells.push(
        <td
          key={day}
          className={`p-1 text-center ${isFuture ? "bg-gray-200 text-gray-400" : "cursor-pointer " + (isSelected ? "bg-blue-500 text-white rounded" : "hover:bg-blue-200")}`}
          onClick={isFuture ? undefined : () => onChange(dateObj)}
        >
          {day}
        </td>,
      );
    }
    const weeks = [];
    for (let i = 0; i < cells.length; i += 7) {
      weeks.push(<tr key={i}>{cells.slice(i, i + 7)}</tr>);
    }
    return weeks;
  };

  return (
    <div className="bg-white border border-gray-300 rounded p-2">
      <div className="flex justify-between items-center mb-2">
        <button onClick={handlePrevMonth} className="px-2">
          <FaChevronLeft />
        </button>
        <span className="py-2 w-40 text-center">
          {currentDate.toLocaleString("default", { month: "long" })}{" "}
          {currentDate.getFullYear()}
        </span>
        <button onClick={handleNextMonth} className="px-2">
          <FaChevronRight />
        </button>
      </div>
      <table className="w-full text-sm">
        <thead>
          <tr>
            {daysOfWeek.map((day) => (
              <th key={day} className="p-1">
                {day}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{renderDays()}</tbody>
      </table>
    </div>
  );
};

export default CustomDatePicker;
